module.exports = __webpack_public_path__ + "img/model_46_zh.6f31e31f.jpg";